import { render, staticRenderFns } from "./ContentImageLightbox.vue?vue&type=template&id=60429887&scoped=true"
import script from "./ContentImageLightbox.vue?vue&type=script&lang=ts"
export * from "./ContentImageLightbox.vue?vue&type=script&lang=ts"
import style0 from "./ContentImageLightbox.vue?vue&type=style&index=0&id=60429887&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60429887",
  null
  
)

export default component.exports